<input #fileUpload type="file" id="fileUpload" (change)="fileChange($event)" [hidden]="!showInput" />
<button class="btn btn-primary ml-3 btn-sm" (click)="fileUpload.click()">
    Upload File (.xlsx)
</button>
<downloadfile #download></downloadfile>
